import * as React from 'react'
import { Button, ButtonGroup } from '@cloudflare/component-button'
import { FiddleEditor } from './FiddleEditor'
import { FlexPassthrough, EditorWrapper } from './common'
import { KeyboardEventListener } from '../lib/KeyboardEventListener'
import logoUrl from '../assets/logo.svg'
import {
  SidebarModulePadding,
  SidebarAltTheme,
  ButtonHotKey,
} from './FiddleSidebarModules'

export interface IFiddleSidebarProps {
  editorValue: string
  editorDidMount?: (
    editor: monaco.editor.ICodeEditor,
    code: typeof monaco,
  ) => void
  isMacOs: boolean
  shareUrl: string
  hideOverflow: boolean
  requestSave: () => void
}

export class FiddleSidebar extends React.Component<
  IFiddleSidebarProps
> {
  public keyboard: KeyboardEventListener

  constructor(props: IFiddleSidebarProps) {
    super(props)
  }

  componentWillUnmount() {
    if (this.keyboard) {
      this.keyboard.stop()
    }
  }

  render() {
    return (
      <FlexPassthrough direction="column">
        <div>
          <SidebarModulePadding>
            <div style={{ display: 'inline-block', width: '100px' }}>
              <img src={logoUrl} />
            </div>
          </SidebarModulePadding>
        </div>
        <div>
          <SidebarModulePadding>
            <p>
              Transform requests on the edge using JavaScript.
              <br />
              <a href="https://workers.cloudflare.com">
                Learn more about Cloudflare Workers
              </a>
            </p>
          </SidebarModulePadding>
        </div>
        <EditorWrapper hideOverflow={this.props.hideOverflow}>
          <FiddleEditor
            value={this.props.editorValue}
            editorDidMount={this.props.editorDidMount}
          />
        </EditorWrapper>
        <div>
          <SidebarModulePadding>
          <p style={{
            fontSize: '0.7rem'
          }}>
            <strong>You can share this code snippet with others by sending them its unguessable URL from your browser's address bar.</strong>
          </p>
          </SidebarModulePadding>
        </div>
        <div style={{ textAlign: 'right' }}>
          <SidebarAltTheme>
            <SidebarModulePadding>
              <ButtonGroup spaced={true}>
                <Button type="primary" onClick={this.props.requestSave}>
                  Update{' '}
                  <ButtonHotKey>
                    ({this.props.isMacOs ? '⌘S' : 'ctrl+s'})
                  </ButtonHotKey>
                </Button>
              </ButtonGroup>
            </SidebarModulePadding>
          </SidebarAltTheme>
        </div>
      </FlexPassthrough>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FiddleSidebar.tsx